<template>
  <div class="scores-container">
    <!-- Net Worth Card -->
    <div class="risk-score-card">
      <i class="fas fa-balance-scale risk-icon"></i>
      <span style="font-size: 1em;">Net Worth: ${{ formattedNetWorth }}</span>
      <button @click="refreshNetWorth" class="refresh-button">
        <i class="fas fa-sync-alt">Refresh</i>
      </button>
    </div>


    <!-- Financial Assets Card -->
    <div class="score-item">
      <div class="card">
        <div class="icon-title-container">
          <i class="fas fa-wallet score-icon"></i>
          <div class="title">Financial Assets</div>
        </div>
        <div class="score">$ {{ formattedTotalFinancialAssets }} CAD</div>
      </div>
    </div>

    <!-- Personal Assets Card -->
    <div class="score-item">
      <div class="card">
        <div class="icon-title-container">
          <i class="fas fa-home score-icon"></i>
          <div class="title">Personal Assets</div>
        </div>
        <div class="score">$ {{ formattedTotalPersonalAssets }} CAD</div>
      </div>
    </div>

    <!-- Liabilities Card -->
    <div class="score-item">
      <div class="card">
        <div class="icon-title-container">
          <i class="fas fa-university score-icon"></i>
          <div class="title">Liabilities</div>
        </div>
        <div class="score">$ {{ formattedTotalLiabilities }} CAD</div>
      </div>
    </div>    <br>  <!-- Refresh Button -->

  </div>
</template>
<script>
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
import { Auth } from 'aws-amplify';

export default {
  setup() {
    const liabilities = ref([]);
    const personalAssets = ref([]);
    const financialAssets = ref([]);

    const fetchLiabilities = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/liabilities/', {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        liabilities.value = response.data.filter(liability => liability.source === 'manual');
      } catch (error) {
        console.error('Error fetching liabilities:', error);
      }
    };

    const fetchPersonalAssets = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/personal-assets/', config);
        personalAssets.value = response.data;
      } catch (error) {
        console.error('Error fetching personal assets:', error);
      }
    };

    const fetchFinancialAssets = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const cognitoSub = user.attributes.sub;
        const response = await axios.get('https://api.riskypaws.com/frontoffice/api/assets/', {
          headers: { 'X-Cognito-Sub': cognitoSub }
        });
        financialAssets.value = response.data;
      } catch (error) {
        console.error('Error fetching financial assets:', error);
      }
    };

    const formattedTotalFinancialAssets = computed(() => {
      return financialAssets.value.reduce((sum, asset) => sum + parseFloat(asset.current_balance || 0), 0).toFixed(2);
    });

    const formattedTotalPersonalAssets = computed(() => {
      return personalAssets.value.reduce((sum, asset) => sum + parseFloat(asset.value || 0), 0).toFixed(2);
    });

    const formattedTotalLiabilities = computed(() => {
      return liabilities.value.reduce((sum, liability) => sum + parseFloat(liability.current_balance || 0), 0).toFixed(2);
    });


    const formattedNetWorth = computed(() => {
      const totalLiabilities = liabilities.value.reduce((sum, liability) => sum + parseFloat(liability.current_balance), 0);
      const totalPersonalAssets = personalAssets.value.reduce((sum, asset) => sum + parseFloat(asset.value), 0);
      const totalFinancialAssets = financialAssets.value.reduce((sum, asset) => sum + parseFloat(asset.current_balance), 0);

      const netWorth = totalFinancialAssets + totalPersonalAssets - totalLiabilities;
      return netWorth.toFixed(2); // Format to 2 decimal places
    });

    const refreshNetWorth = async () => {
      await fetchLiabilities();
      await fetchPersonalAssets();
      await fetchFinancialAssets();
    };

    onMounted(async () => {
      await fetchLiabilities();
      await fetchPersonalAssets();
      await fetchFinancialAssets();
      onMounted(refreshNetWorth);
    });

    return {
      formattedNetWorth,
      formattedTotalFinancialAssets,
      formattedTotalPersonalAssets,
      formattedTotalLiabilities,
      refreshNetWorth,
    };
  }
};
</script>


  
<style scoped>


.scores-container {
  display: flex;
  flex-wrap: wrap; /* Allows items to move to the next row on smaller screens */
  justify-content: center; /* Centers items */
  align-items: center;
  width: 100%;
  border: 2px solid #000;
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}





.icon-title-container {
display: flex;
flex-direction: column;
align-items: center;
}




.card {
background-color: #fff;
border-radius: 10px;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
padding: 20px;
text-align: center;
}

.card:hover {
transform: translateY(-10px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.icon-title-container {
display: flex;
flex-direction: column;
align-items: center;
margin-bottom: 10px;
}

.score {
font-size: 1.2em;
font-weight: bold;
}

.scores-container {
display: flex;
justify-content: space-around;
align-items: center;
width: 100%;
border: 2px solid #4A148C;
border-radius: 10px;
padding: 20px;
box-sizing: border-box;
background-color:white;
flex-direction: row;
flex-wrap: wrap;  /* Allows items to move to the next row on smaller screens */
justify-content: space-around;
}

.score-item {
flex: 1 1 auto;  /* Allows items to grow and shrink */
text-align: center;
margin: 10px;  /* Adds some space around each item */
/* ... */
}


.risk-score-card {
display: flex;
align-items: center;
width: 100%;
padding: 20px;
margin-bottom: 20px;
background-color: #36454f;;
color: white;
font-size: 24px;
border-radius: 10px;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.risk-icon {
margin-right: 10px;
font-size: 30px;
}

button {
  background-color: #4A148C; /* Purple background */
  color: white; /* White text */
  border: none;
  border-radius: 5px; /* Rounded corners */
  padding: 10px 20px; /* Padding inside the button */
  cursor: pointer; /* Cursor style */
  transition: background-color 0.3s ease; /* Smooth transition for hover effect */
}

button:hover {
  background-color: black; /* Black background on hover */
}
</style>